import { Component, OnInit } from '@angular/core';
import { LeaseRemarksList } from 'src/app/models/lease-quote';
import { AuthService } from 'src/app/services/auth.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'logzy-quote-remarks',
    templateUrl: './quote-remarks.component.html',
    styleUrls: ['./quote-remarks.component.scss']
})
export class QuoteRemarksComponent implements OnInit {

    remarks: string = '';
    is_internal: boolean = true;
    isCustomer: boolean;
    remarksList: LeaseRemarksList[] = [];
    base_url = environment.baseApiUrl;

    constructor(private authService: AuthService,
        private requestService: RequestApiService) { }

    ngOnInit(): void {
        this.isCustomer = this.authService.isCustomer();
        this.getRemarksList();
    }

    getRemarksList() {
        this.requestService.getRemarksList(this.requestService.selectedRequest?.id).subscribe(res => {
            this.remarksList = res.results;
        })
    }

    addNewRemarks() {
        if (this.isCustomer) {
            this.is_internal = false;
        }
        if (this.remarks.length != 0) {
            this.requestService.postRequestRemarks(this.requestService.selectedRequest?.id, this.remarks, this.is_internal).subscribe(res => {
                this.remarksList = [];
                this.getRemarksList();
                this.remarks = '';
            })
        } else {
            window.alert('Please enter remarks')
        }
    }
}
